<script>
import FCIDataTable from '@/modules/fptai/components/FCIDataTable'

export default {
    name: 'ListViewMixin',
    components: { FCIDataTable },
    data () {
        return {
            items: [],
            pagination: {
                page: 1,
                pageSize: 10
            },
            searchKey: ''
        }
    },
    computed: {
        headers () {
            return []
        },
        filterItems () {
            let searchKey = this.$ut.noAccent(this.searchKey)
            if (!searchKey) {
                return this.items
            }
            return this.items.filter(item => this.$ut.noAccent(item.name).includes(searchKey))
        }
    },
    mounted () {
        this.refresh()
    },
    methods: {
        refresh () {
        },
        selectItem (item) {
            let slash = this.$route.path.endsWith('/') ? '' : '/'
            this.$router.push(this.$route.path + slash + item.id)
        },
        addItem () {
        },
        editItem (item, index) {
            this.$refs.ItemEditor.open(item).then(() => {
                this.refresh()
            })
        },
        async deleteItem (item, index) {
            let confirm = await this.$appService.confirm(this.$t('confirmDelete', { item: item.name }))
            if (confirm) {
                this.onDeleteItem(item, index)
            }
        },
        onDeleteItem () {
        }
    },
    watch: {
        pagination: {
            immediate: false,
            handler: function () {
                this.refresh()
            }
        },
        filter: {
            immediate: false,
            deep: true,
            handler: function () {
                this.refresh()
            }
        }
    }
}
</script>

<style scoped>

</style>
